import { useEffect } from 'react'
import CustomLoading from './CustomLoading'
import { getTokenFromApp } from '../shared-utils/getTokenFromApp'
import { getRefreshToken } from '../shared-constants/localstorage'
import { useLocation, useSearchParams } from 'react-router-dom'

export const Authentication = (props: any) => {
  const [searchParams] = useSearchParams()
  const tokenFromApp = searchParams.get('token')
  const { pathname } = useLocation()

  // if (getRefreshToken() === null && !tokenFromApp) return <Login />
  // else {
  //   getTokenFromApp(true, tokenFromApp)
  //   return props.children
  // }

  if (tokenFromApp) {
    getTokenFromApp({
      justCheckIsRefreshToken: true,
      tokenFromApp: tokenFromApp,
      pathname: pathname,
    })
  } else {
    getTokenFromApp({ justCheckIsRefreshToken: true })
  }
  return props.children
}

//   if (getRefreshToken() === null) return <Login />
//   else {
//     getTokenFromApp(true)
//     // postGetRefreshTokenToApp()
//     return props.children
//   }
// }

const Login = () => {
  const [searchParams] = useSearchParams()
  const tokenFromApp = searchParams.get('token')
  useEffect(() => {
    getTokenFromApp({ justCheckIsRefreshToken: false, tokenFromApp: '' })
  }, [])
  return <>{tokenFromApp ? <CustomLoading /> : <></>}</>
}

// ?token=RDAxMkNFMTY5RkMxOTFGRTYxMzg0MTMyMUI4ODNCNEU0NjUzRjAyRjBDQjRCRTIyQzQxMjg2OEFGREJCODc1RA==
